import React from 'react'

import type { PinInputReatom } from './atoms'
import type { PinState } from './pin-dots'

export type PinInputContextValue = {
  model: PinInputReatom
  state: PinState
  length: number
}

export const PinInputContext = React.createContext<PinInputContextValue>({
  model: undefined as never,
  state: 'idle',
  length: 4,
})
